import {
  Avatar,
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getS3Url } from 'src/constants';

const DriverSelector = ({
  drivers = [],
  vehicles = [],
  errors,
  driverValue,
  vehicleValue,
  onChangeDriver,
  onChangeVehicle,
  sx = {},
}) => {
  const selectedDriver = drivers.find((driver) => driver.id === driverValue);
  const { t } = useTranslation('translation');
  return (
    <Stack sx={sx} direction="row" spacing={2}>
      <FormControl error={errors?.driverId?.message} fullWidth>
        <InputLabel>{t('donations.driver')}</InputLabel>
        <Select
          startAdornment={
            <Avatar
              sx={{
                width: 35,
                height: 35,
                mr: 1,
                border: (theme) => `1px solid ${theme.palette.divider}`,
              }}
              src={
                selectedDriver?.image ? getS3Url(selectedDriver?.image) : null
              }
            />
          }
          label={t('donations.driver')}
          value={driverValue}
          onChange={(e) => onChangeDriver(e.target.value)}
          sx={{
            '& .MuiSelect-select': {
              ...(selectedDriver ? { py: '8px !important' } : {}),
            },
          }}
        >
          <MenuItem value="unassigned">{t('donations.unassigned')}</MenuItem>
          {drivers.map((driver) => (
            <MenuItem key={driver.id} value={driver.id}>
              <Box
                sx={{
                  opacity: driver.is_available ? 1 : 0.5,
                }}
              >
                <Typography fontSize="15px" fontWeight={600}>
                  {driver.name} &nbsp;
                  {!driver.is_available && `(${t('common.unavailable')})`}
                </Typography>
                <Typography
                  fontSize="12px"
                  textTransform="uppercase"
                  color="text.secondary"
                  variant="body2"
                  noWrap
                >
                  {driver.user_formatted_address || driver.email}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
        {errors?.driverId?.message && (
          <FormHelperText error>{errors?.driverId?.message}</FormHelperText>
        )}
      </FormControl>

      <FormControl fullWidth>
        <InputLabel>{t('donations.vehicle')}</InputLabel>
        <Select
          label={t('donations.vehicle')}
          value={vehicleValue}
          onChange={(e) => onChangeVehicle(e.target.value)}
        >
          {vehicles.map((vehicle) => (
            <MenuItem key={vehicle.id} value={vehicle.id}>
              {vehicle.name} ({vehicle.capacity.value} {vehicle.capacity.unit})
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
};

export default DriverSelector;
